var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slide"},[_c('el-carousel',_vm._l((_vm.imgList),function(item){return _c('el-carousel-item',{key:item.img},[_c('img',{attrs:{"src":item.img,"alt":"美团轮播"}})])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }